<template>
    <div class="Details">
    <section class="container">
        <div class="columns">
            <div class="column is-full">
            
              <div class="box" v-if="datasetDocuments">
                <!-- <h2 class="title is-5">The {{model.name}} model has <b-tag type="is-danger">{{ totalErrors || datasetDocuments.length }}</b-tag> errors</h2> -->
                <p class="subtitle is-5">Improve your model performance by checking mislabeling data or missing of relevant data</p>
                <p class="subtitle is-6"><b>Check it: </b>You can check the original label and predicted label to see if it refer to mislabeling</p>
                <p class="subtitle is-6"><b>Suggestions: </b>If your labels are all ok, you may need to upload more data or use our new feature to <b>generate synthetic data</b></p>
                
                <b-button tag="router-link" :to="{ path: '/datasets/'+model.datasets[0]+'/data/' }">
                          <h2 class="is-danger">&nbsp;Fix labels manually</h2>
                </b-button>
                &nbsp;&nbsp;

                <b-button tag="router-link" :to="{ path: '/datasets/'+model.datasets[0]+'/data/' }">
                          <h2 class="is-danger">&nbsp;Upload more data</h2>
                </b-button>
                &nbsp;&nbsp;
                <b-button tag="router-link" :to="{ path: '/datasets/'+model.datasets[0]+'/data/' }">
                          <h2 class="is-danger">&nbsp;Generate synthetic data</h2>
                </b-button>
              </div>
            </div>
        </div>
        <!-- <div class="block">
            Labels com alta taxa de erro. Voce pode conferir/ajustar as labels, para melhorar a performance do modelo.
        </div> -->
        <!-- {{ groupBy(this.datasetDocuments, "label") }} -->
        
        <div class="columns is-gapless box" v-if="datasetDocuments">
                    <br>
                    <b-table 
                        :data="getData()" 
                        :per-page="50"
                        :selected.sync="selected"
                        paginated>
                        
                        <b-table-column field="text" label="Text" sortable searchable v-slot="props">
                          {{ props.row.text }}
                        </b-table-column>

                        <b-table-column field="label" label="Label" sortable searchable v-slot="props">
                            
                            <span>{{ props.row.label }}</span>
                        </b-table-column>

                        <b-table-column v-if="viewFilter=='predicted'" field="predicted" label="Predicted / Confidence" sortable searchable v-slot="props">
                          <b-tag size="is-medium">
                              <!-- <b-tag type="is-primary is-light">Pred</b-tag> -->
                              {{ props.row.predicted }} 
                              {{ props.row.predicted_proba.toFixed(2)}}
                              </b-tag>
                        </b-table-column>
                        
                    </b-table>
                
            </div>
    </section>

    </div>
</template>
<script>
import { Plotly } from 'vue-plotly'

export default {
     props: ["boardId","model", "dataset"],
     name: "Training",
     data: function() {
            return {
                candidateLabels: [],
                summary: false,
                viewFilter: 'predicted',
                totalErrors: 0,
                selected: {text: false, label: 'unlabeled'}
            }
    },
    components: {
      Plotly
    },
    computed: {
        datasetDocuments() {
            //let doc = this.$store.state.datasetDocuments;
            let doc = this.$store.state[`datasetDocuments-${this.model.datasets[0]}-predicted`];
            // this.totalErrors = doc.length
            return doc
       }
     },
     created() {
        const datasetId = this.model.datasets[0]
        this.$store.dispatch("getAllDatasetDocuments", {datasetId: datasetId, filter: {view: 'predicted'}, model_version: this.model.model_version});
        
        // this.summary = this.groupBy(this.datasetDocuments, "label")
        if(this.datasetDocuments){
            this.totalErrors = this.datasetDocuments.length
        }

     },
      methods: {
        getFilter(item){
            
            // all, labeled, unlabeled, predicted
            if(this.viewFilter == 'predicted'){
              return item.predicted != undefined;
            } else if(this.viewFilter == 'predicted' && this.model.model_version != undefined){
              return item.predicted != undefined && item.modelVersionNumber == this.model.model_version;
            } else {
              return true
            }
         },
        getData(){
            if(this.viewFilter != 'all'){
              return this.datasetDocuments.filter( 
                item => (
                  this.getFilter(item)
                )
              )
            } else {
              return this.datasetDocuments
            }
         },
       updateLabel(dataDoc){
            const toUpdate = {
              datasetId: this.dataset.id,
              docId: dataDoc.id,
              update: {
                label: dataDoc.label
              }
            }
            this.$store.dispatch("updateDatasetDocument", 
                toUpdate
            );
         },
          groupBy(arr, key){
            const groupBy = function(xs, key) {
                return xs.reduce(function(rv, x) {
                    (rv[x[key]] = rv[x[key]] || []).push(x);
                    return rv;
                }, {});
            }
            
            var x = groupBy(arr, key);

            var keys = Object.keys(x)
            var summary = []
        

            for (const key in keys) {
                console.log(`${key} -> ${keys[key]}`)
                console.log(x[keys[key]].length)
                console.log(x[keys[key]])
                summary.push({"label": x[keys[key]], "sum": x[keys[key]].length})
                // var subArr = groupBy(x[keys[key]], "predicted")
                // var subKeys = Object.keys(subArr)
                // for (const subkey in subKeys){
                //     console.log(`${subkey} -> ${subKeys[subkey]}`)
                //     console.log(subKeys[subkey].length)
                // }
            }
            
            return summary
          },
          download(){
          }
     }
   };
</script>